export default __webpack_public_path__ + "static/media/img2.7fc16252.png";